/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Entity identity for an experiment assignment; provide exactly one customer, lead, or property grain. */
export type AssignmentGrainInput =
  {   /** Customer identity for the assignment. */
  customer: CustomerAssignmentGrainInput; lead?: never; property?: never; }
  |  { customer?: never;   /** Seller lead identity for the assignment. */
  lead: LeadAssignmentGrainInput; property?: never; }
  |  { customer?: never; lead?: never;   /** Property identity for the assignment. */
  property: PropertyAssignmentGrainInput; };

/** Customer identity used to evaluate or record an experiment assignment. */
export type CustomerAssignmentGrainInput = {
  /** Anonymous visitor identifier used when no customer account is available. */
  anonymousId?: Types.Scalars['UUID']['input'] | null | undefined;
  /** Customer identifier whose assignments should be evaluated. */
  customerId?: Types.Scalars['UUID']['input'] | null | undefined;
};

/** Entity and experiment keys for retrieving variant assignments. */
export type ExperimentVariantsInput = {
  /** Entity identity whose assignments should be retrieved. */
  grain: AssignmentGrainInput;
  /** Experiment or feature-flag keys to retrieve; results preserve first-seen key order and remove duplicates. */
  keys: Array<Types.Scalars['NonEmptyString']['input']>;
};

/** Seller lead identity used to evaluate or record an experiment assignment. */
export type LeadAssignmentGrainInput = {
  /** Optional customer identity associated with the seller lead. */
  customer?: CustomerAssignmentGrainInput | null | undefined;
  /** Seller lead identifier for the assignment. */
  sellerLeadId: Types.Scalars['UUID']['input'];
};

/** Property identity for an experiment assignment. */
export type PropertyAssignmentGrainInput = {
  /** Address whose experiment assignment is evaluated. */
  addressId: Types.Scalars['UUID']['input'];
};

export type CosmosOnboardingZeroArmQueryVariables = Exact<{
  input: Types.ExperimentVariantsInput;
  addressId: Types.Scalars['UUID']['input'];
}>;


export type CosmosOnboardingZeroArmQuery = { viewer: { session: { isImpersonated: Types.Scalars['Boolean']['output'] } | null }, experiments: { evaluations:
      | { __typename: 'ExperimentsQueryEvaluationsSuccess', data: Array<{ key: Types.Scalars['NonEmptyString']['output'], value: Types.Scalars['String']['output'] | null, variationId: Types.Scalars['Int']['output'] | null }> }
      | { __typename: 'InvalidInputError' }
      | { __typename: 'NotFoundError' }
      | { __typename: 'UnauthorizedError' }
     | null } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const CosmosOnboardingZeroArmDocument = /*#__PURE__*/ new TypedDocumentString(`
    query CosmosOnboardingZeroArm($input: ExperimentVariantsInput!, $addressId: UUID!) {
  viewer {
    session {
      isImpersonated
    }
  }
  experiments {
    evaluations(input: $input, addressId: $addressId) {
      __typename
      ... on ExperimentsQueryEvaluationsSuccess {
        data {
          key
          value
          variationId
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CosmosOnboardingZeroArmQuery, CosmosOnboardingZeroArmQueryVariables>;